import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import {
  federalDistrictSearchStatus,
  StatusTypes,
} from '@dashboard-experience/utils';
import Search from '../Search/Search';
import { hasAssessment } from '../utils';

interface Props {
  search: Record<string, any>;
  districtSearches: Array<Record<string, any>>;
  reportStatusType: 'assess' | 'legacy';
}

const FederalCriminalSearch = ({
  search,
  districtSearches,
  reportStatusType,
}: Props): React.ReactElement => {
  const status = federalDistrictSearchStatus(
    districtSearches,
    reportStatusType,
  );

  // the Search component uses the presence of the assessment object as a flag
  // to determine when to use assess styling, but federal searches do not include
  // assessment objects - only their associated district searches do. This tells
  // the search component to use assess styles on the federal search panel, as
  // long as the associated district searches use assess styles.

  const modifiedSearch =
    search && !hasAssessment(search) && reportStatusType === StatusTypes.Assess
      ? {
          ...search,
          assessment: {
            display: {
              decision: status || search.status,
            },
          },
        }
      : search;

  return (
    <Search
      dataTestId='federal-searches'
      showFilteredByAdjudicationRecords
      type='criminal'
      title={i18n.getStr('components.criminalScreenings.federalSearch')}
      search={modifiedSearch}
      assessmentEnabled
      status={status}
    />
  );
};

export default FederalCriminalSearch;
